import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useResourceSharingStore } from './resourceSharingStore.js';
import { pick } from '@fabric-app/utils/object/manipulation';
import { ModalShare } from './ModalShare.js';

let timeout;
const ModalShareWithGlobalStore = () => {
  const { close, resourceId: resourceIdGlobalState, tab: tabGlobalState } = useResourceSharingStore((state) => pick(state, [
    "close",
    "resourceId",
    "tab"
  ]));
  const [resourceId, setResourceId] = useState(resourceIdGlobalState);
  useEffect(() => {
    clearTimeout(timeout);
    if (resourceIdGlobalState) {
      timeout = setTimeout(() => {
        setResourceId(resourceIdGlobalState);
      }, 200);
    } else {
      timeout = setTimeout(() => {
        setResourceId(null);
      }, 500);
    }
  }, [
    resourceIdGlobalState
  ]);
  return /* @__PURE__ */ jsx(ModalShare, {
    open: !!resourceIdGlobalState,
    onOpenChange: close,
    resourceId,
    defaultTab: tabGlobalState
  });
};

export { ModalShareWithGlobalStore };
//# sourceMappingURL=ModalShareWithGlobalStoreProps.js.map
